/**
 * Slots are shown on the MERCHANT's clock and the page says which one — a
 * booker abroad reads "Times shown in Israel Time" instead of silently
 * converting in their head (or not). No zone from the server → the browser's.
 *
 * Labels are in the page's language. Every string on the booking page is
 * English (en is the only locale), but the day chips used the device locale,
 * so a phone set to Hebrew showed "יום א׳, 11 באוק׳" between English
 * sentences (owner, 2026-10-08). The zone stays the merchant's; only the
 * words follow the page.
 */
export const BOOKING_LOCALE = 'en-GB';
export function zoneOpt(tz: string | null | undefined): { timeZone?: string } {
  return tz ? { timeZone: tz } : {};
}
export function dayKey(iso: string, tz?: string | null): string {
  return new Date(iso).toLocaleDateString('en-CA', zoneOpt(tz));
}
export function dayLabel(iso: string, tz?: string | null): string {
  return new Date(iso).toLocaleDateString(BOOKING_LOCALE, { weekday: 'short', month: 'short', day: 'numeric', ...zoneOpt(tz) });
}
export function timeLabel(iso: string, tz?: string | null): string {
  return new Date(iso).toLocaleTimeString(BOOKING_LOCALE, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', ...zoneOpt(tz) });
}
